/** Returns a promise that waits the given number of milliseconds. */
const sleep = (ms: number) => {
  return new Promise(resolve => window.setTimeout(resolve, ms));
};

// Nil is used so that we can define a generic type T as non-nil.
// With this (T | Nil) we get that the given type is T OR Nil, if we can then prove that the param
// is non-Nil, then we can return a non-Nil generic type T.
type Nil = null | undefined;

/**
 * Polls the given function for a value, once the value is
 * no longer falsey (!value returns true), we return the value.
 */
export async function whenExists<T>(fn: () => T | Nil, ms: number): Promise<T> {
  let v = await Promise.resolve(fn());
  while (!v) {
    await sleep(ms);
    v = await Promise.resolve(fn());
  }
  return v;
}

/**
 * whenSet returns a settable promise, allowing one to block until the promise
 * is explictly resolved elsewhere.
 */
export function whenSet<T>() {
  let r: (value: T | PromiseLike<T>) => void = () => {};
  const p = new Promise<T>(resolve => (r = resolve));
  return { promise: p, resolve: r };
}
